import * as amplitude from '@amplitude/analytics-browser'

export interface UserProperties {
  registrationNumber: string | null
  forename: string
  surname: string
  email: string
}

declare global {
  interface Window {
    FS: {
      event: (eventName: string, body: any) => void
    }
    gtag?: any // Need to set this so we can check it's available on the window object
  }
}

const logFullStoryCustomEvent = (eventName: string, body?: any) => {
  if (window.FS) {
    window.FS.event(eventName, body)
  }

  return null
}

export const trackGtagEvent = (eventName: string, data?: any) => {
  if (window.gtag) {
    window.gtag('event', eventName, data)
  }
}

export const trackEvent = (eventName: string, data?: any) => {
  const eventData = {
    branding: window.branding ?? 'Blue',
    url: window.location.href,
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    ...data,
  }
  trackGtagEvent(eventName, eventData)
  logFullStoryCustomEvent(eventName, eventData)
  amplitude.track(eventName, eventData)
}

export const trackAmplitudeEvent = (eventName: string, data?: any) => {
  const eventData = {
    branding: window.branding ?? 'Blue',
    app: 'Tesla',
    url: window.location.href,
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    ...data,
  }
  amplitude.track(eventName, eventData)
}

export const setAmplitudeUserProperty = (propertyName: string, value: any) => {
  const identifyEvent = new amplitude.Identify()
  identifyEvent.set(propertyName, value)
  amplitude.identify(identifyEvent)
}

export const getAmplitudeUserProperties = () => {
  return {
    deviceId: amplitude.getDeviceId(),
    userId: amplitude.getUserId(),
    sessionId: amplitude.getSessionId(),
  }
}

export const setAmplitudeUserRegProperty = (value: any) => {
  setAmplitudeUserProperty('RegistrationNumber', value)
}

export const setAmplitudeUserProperties = (value: UserProperties) => {
  const identifyEvent = new amplitude.Identify()
  identifyEvent.set('RegistrationNumber', value.registrationNumber ?? '')
  identifyEvent.set('Forename', value.forename)
  identifyEvent.set('Surname', value.surname)
  identifyEvent.set('Email', value.email)
  amplitude.identify(identifyEvent)
}

export const trackPurchase = (purchaseAmount: number) => {
  trackEvent('purchase', { purchaseAmount })

  if (purchaseAmount) {
    const amplitudePurchaseEvent = new amplitude.Revenue().setPrice(
      purchaseAmount,
    )
    amplitude.revenue(amplitudePurchaseEvent)
  }
}
